import { liveModelInfoJson } from './userList/components/server';
import LocalStore from '@/utils/store';
import { normalPerson, NormalPersonParams, UserItemJson } from './microphone/service';
import { ShowUserInfo } from '../../typings';
import { RoomInfoState } from '@/views/Voice/store/module/roomInfo';
import VoiceFn from '../../fn';

// export function returnCanvasRatio(modelType: number, desc: string, info?: liveModelInfoJson) {
//   if (modelType === 2) {
//     if (info && info.canvasRatio) {
//       if (info.canvasRatio === desc) return true;
//     }
//   }
//   return false;
// }

export function returnCanvasRatio(modelType: number, desc: string, info?: liveModelInfoJson) {
  if (modelType === 2) {
    if (info) {
      if (info.canvasRatio && info.canvasRatio === desc) return true;
      if (!info.canvasRatio && desc === '16:9') return true;
    }
  }
  return false;
}

export function followAnchorFn(anchorId: number) {
  const followAnchors: any = LocalStore.getValue('VOICE_BASE_FOLLOW_ANCHOR', []);
  if (followAnchors.length) {
    const bol = followAnchors.some((item: any) => item === anchorId);
    if (!bol) {
      followAnchors.push(anchorId);
      LocalStore.setValue('VOICE_BASE_FOLLOW_ANCHOR', followAnchors);
    }
    return !bol;
  } else {
    followAnchors.push(anchorId);
    LocalStore.setValue('VOICE_BASE_FOLLOW_ANCHOR', followAnchors);
    return true;
  }
}

export async function getUserChatInfo(info: NormalPersonParams) {
  const { data } = await normalPerson(info);
  const dataInfo: UserItemJson = {
    data: true,
    roleId: data.roleId,
    isBanned: data.isBaned,
    isPrivateChat: data.isPrivateChat,
    sex: data.sex
  };
  return dataInfo;
}

/** 语音公聊弹幕校验参数，roomType：1主房间 2子房间（0秀场直播不在此处理） */
export function getDanmakuCheckParams(roomInfo: Pick<RoomInfoState, 'roomId' | 'mainRoomId'>) {
  if (roomInfo.roomId === roomInfo.mainRoomId) {
    return { roomType: 1, roomId: roomInfo.roomId, live_platform: VoiceFn.getVoiceLivePlatform() };
  }
  return { roomType: 2, roomId: roomInfo.roomId, live_platform: VoiceFn.getVoiceLivePlatform() };
}

export function getShowUserInfo(showUser?: ShowUserInfo) {
  if (VoiceFn.getVoiceLivePlatform() === '96show' && showUser) {
    return {
      uid: Number(showUser?.id || 0),
      nickname: showUser?.nick_name ?? '',
      userName: showUser?.nick_name ?? '',
      head_img: showUser?.head_img ?? '',
      showUserId: showUser?.show_user_id ?? ''
    };
  }
  return {};
}

/**
 * 语音房举报 anchorUserId
 * - 娱乐(0)/自由(1)：传 0
 * - 直播(2)：有 1 麦主播则传主播 ID，否则传 0
 */
export function getVoiceReportAnchorUserId(roomInfo: Pick<RoomInfoState, 'modelType'>): number {
  if (roomInfo.modelType === 2) {
    return Number(LocalStore.getValue('VOICE_LIVEANCHOR_USERID', 0)) || 0;
  }
  return 0;
}

export function hasCurrentUser(boxUserId?: number, infoUid?: number, showUser?: ShowUserInfo) {
  const intBoxUserId = Number(boxUserId ?? 1);
  const intiInfoUid = Number(infoUid ?? 0);
  const showUserId = Number(getShowUserInfo(showUser)?.uid ?? -1);
  const userIds = [intBoxUserId, showUserId];
  if (userIds.includes(intiInfoUid)) {
    return true;
  }
  return false;
}

/** V2 总开关，设为 false 可一键回滚到 V1 */
export const ENABLE_96SHOW_AUDIENCE_V2 = true;

/** 当前直播/语音平台是否为 96show */
export function is96showRoom() {
  return VoiceFn.getVoiceLivePlatform() === '96show';
}

/** 是否启用96show V2在线观众能力开关 */
export function is96showAudienceV2Enabled() {
  if (!ENABLE_96SHOW_AUDIENCE_V2) return false;
  if (!is96showRoom()) return false;
  return true;
}
